import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import DashboardMenu from '@/views/dashboard/appBar/DashboardMenu.vue';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import { usePermissionComposable } from '@/composables/usePermission';
import { i18n } from '@/plugins/vue-i18n';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { store } from '@/store/index';
import { readUserLocale } from '@/store/main/getters';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBar',
  setup(__props) {

const $t = i18n.tc.bind(i18n);
const logoUrl = computed(() => {
  return readUserLocale(store) === 'ja-JP'
    ? '/img/top/logo.min.svg'
    : '/img/top/logo.en.min.svg';
});

const { hasPermission, PERMISSIONS: P } = usePermissionComposable();

// SUPPLIER_INQUIRY is a paid feature — the nav tab is disabled with the
// standard add-on tooltip when the company hasn't purchased it.
const { isFeatureActive, COMPANY_FEATURES, generateInactiveMessage } =
  useCompanyFeatureComposable();
const isSupplierInquiryActive = computed(() =>
  isFeatureActive(COMPANY_FEATURES.SUPPLIER_INQUIRY)
);
const supplierInquiryInactiveTooltip = computed(() =>
  generateInactiveMessage($t(sharedMessages.supplierInquiry))
);

const m = defineMessages({
  sdsUpload: 'SDS登録',
  sdsError: 'データ化保留・不可SDS',
});

return { __sfc: true,$t, logoUrl, hasPermission, P, isFeatureActive, COMPANY_FEATURES, generateInactiveMessage, isSupplierInquiryActive, supplierInquiryInactiveTooltip, m, DashboardMenu, sharedMessages }
}

})